// extracted by mini-css-extract-plugin
export default {"mb-3":"Pages_mb-3__EvRY8","mb-2":"Pages_mb-2__q21I+","section":"Pages_section__nUz+v","header":"Pages_header__XvhUG","container":"Pages_container__M7a3N"};